/**
 * about.jsx
 *
 * Page "À propos" simple, mais utile pour le SEO et la confiance.
 * - Texte descriptif (contenu crawlable)
 * - Liens internes (maillage)
 * - SEO par route via useSEO
 */

import { Link } from "react-router-dom";
import { useSEO } from "../seo/useSEO";
import "./about.css"; 

function About() {
  useSEO({
    title: "À propos | HowMuch",
    description:
      "HowMuch est un simulateur simple pour visualiser en combien de temps tu atteins un objectif financier et comparer des scénarios de budget.",
    canonicalPath: "/about",
    ogType: "website",
  });

  return (
    <main className="ab">
      <div className="ab-container">
        <nav className="ab-nav" aria-label="Navigation">
          <Link to="/">Accueil</Link>
          <Link to="/simulate">Simulateur</Link>
          <Link to="/blog">Blog</Link>
        </nav>

        <section className="ab-card" aria-label="À propos de HowMuch">
          <h1 className="ab-title">À propos</h1>
          <p className="ab-text">
            HowMuch aide à planifier des objectifs financiers (épargne de sécurité, apport, projet) avec une
            projection simple et lisible. Tu entres un objectif, une mensualité (et optionnellement un rendement),
            et tu visualises le délai.
          </p>

          <p className="ab-text">
            Pour aller plus loin, le simulateur premium permet de comparer des scénarios de budget et de voir des
            paliers (25/50/75/100%).
          </p>

          <h2 className="ab-title">Contact</h2>
          <p className="ab-text">
            <strong>Contactez nous par mail via :</strong> ngdorian0@gmail.com
          </p>
          
        </section>
      </div>
    </main>
  );
}

export default About;
